import { createKeyFactory } from '@clouway/query'

import type { ListUsersParams } from './api/api'

export const usersKeys = createKeyFactory('users')

export const usersListKey = (params?: ListUsersParams) => usersKeys.list(params ?? {})

export const userDetailKey = (id: string) => usersKeys.detail(id)

// Access tab keys live under their own namespace, not nested under `users` —
// a user-profile mutation invalidating `usersKeys.all()` (prefix `['users']`)
// would otherwise also refetch the global catalog reads (products,
// catalogRoles) below, which don't depend on any single user.
export const accessKeys = createKeyFactory('access')

// Catalog reads are global (not per-user) but the assignment and preview
// reads are keyed by user, so a revoke/assign for one user never invalidates
// another's cached tab.
export const productsListKey = () => accessKeys.custom('products')

export const catalogRolesKey = (product: string) => accessKeys.custom('catalogRoles', product)

export const roleAssignmentsKey = (userId: string) => accessKeys.custom('roleAssignments', userId)

export const accessPreviewKey = (userId: string, product: string) =>
  accessKeys.custom('accessPreview', userId, product)
